import _ from 'lodash';
import { createSelector } from 'reselect';

import { isWixEmployeeEmail } from '../../utils/email/email';

const getNameFromEmail = (email) => {
  return email ? email.split('@')[0] : null;
};

const getSessionState = (state) => state.session;

export const getMemberInfo = createSelector(getSessionState, (sessionState) => {
  const userInfo = sessionState.userInfo;

  if (!userInfo) {
    return null;
  }

  // TODO: get only public/verified emails
  const email = _.get(userInfo, 'contactChannels.emails[0].address');

  return {
    ...userInfo,
    name: userInfo.name || getNameFromEmail(email),
    email,
  };
});

export const getUserEmail = createSelector(
  getMemberInfo,
  (userInfo): string | undefined => _.get(userInfo, 'email'),
);

export const getUserAvatarUrl = (state) =>
  _.get(getSessionState(state), 'userInfo.avatar');

export const getMemberId = createSelector(getMemberInfo, (userInfo) =>
  _.get(userInfo, 'id'),
);

export const isLoggedIn = createSelector(getSessionState, (session) =>
  Boolean(session.isLogged),
);

export const isUserExternal = createSelector(
  getUserEmail,
  (email: string): boolean => !isWixEmployeeEmail(email),
);
